/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconNavigationNorth = createReactComponent("outline", "navigation-north", "IconNavigationNorth", [["path", { "d": "M16 21l-4 -8l-4 8l4 -2z", "key": "svg-0" }], ["path", { "d": "M10 9v-6l4 6v-6", "key": "svg-1" }]]);

export { IconNavigationNorth as default };
//# sourceMappingURL=IconNavigationNorth.mjs.map
